import apiClient from ".";
import { ObjectId } from "../models";
import { ISubscription } from "../models/subscription";

export type ProrateItem = {
	description: string | null;
    amount: number;
    currency: string;
    period: {
        start: string;
        end: string;
    };
}
export type UpdateItems = {
	prorationItems: ProrateItem[],
	proration_date: number,
	priceId: string,
	newPriceId: string,
	subscriptionId: string,
	ordId: ObjectId,
	total: number,
	sessionId: string,
	previewOnly: boolean,
}

export const createCheckoutSession = async (body: {orgId: ObjectId, priceId: string}) => {
	const response = await apiClient.post<{sessionId: string}>( `/orgs/${body.orgId}/subscriptions/checkout-session`, body);
	return response.data;
}
export const createCustomerPortalSession = async (body: {orgId: ObjectId, subscriptionId: string}) => {
	const response = await apiClient.post<{url: string}>( `/orgs/${body.orgId}/subscriptions/customer-portal`, body);
	return response.data;
}
export const getSubscription = async (orgId: ObjectId) => {
	const response = await apiClient.get<ISubscription>(`/orgs/${orgId}/subscription`);
	return response.data;
}
export const startFreeSubscription = async (body:{orgId: ObjectId, priceId: string}) => {
	const response = await apiClient.post<{subscriptionId: string}>( `/orgs/${body.orgId}/subscriptions/start-free-plan`, body);
	return response.data;
}
export const updateSubscription = async (body: {
	orgId: ObjectId, 
	subscriptionId: string, 
	newPriceId: string, 
	proration_date?: number,
	previewOnly: boolean,
}) => {
	const response = await apiClient.patch<UpdateItems>(`/orgs/${body.orgId}/subscriptions/update`, body);
	return response.data;
}
export const pauseSubscription = async (body: {orgId: ObjectId, subscriptionId: string}) => {
	const response = await apiClient.patch(`/orgs/${body.orgId}/subscriptions/pause`, body);
	return response.data;
}
export const cancelSubscription = async (body: {orgId: ObjectId, subscriptionId: string}) => {
	const response = await apiClient.patch(`/orgs/${body.orgId}/subscriptions/cancel`, body);
	return response.data;
}
export const resumeSubscription = async (body: {orgId: ObjectId, subscriptionId: string}) => {
	const response = await apiClient.patch<{sessionId: string}>(`/orgs/${body.orgId}/subscriptions/resume`, body);
	return response.data;
}

export const getPlanDetails = async (stripePriceId: string) => {
	const response = await apiClient.get<{planLimits: any}>(`/plans/price/${stripePriceId}`);
	return response.data;
}